module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex",
    staticStyle: {
      "width": "100%",
      "padding": "0px"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('focus', $event)
      }
    }
  }, [(_vm.question) ? _c('div', {
    class: {
      'no-label-question': !_vm.label
    },
    staticStyle: {
      "padding-right": "8px",
      "flex-grow": "1"
    }
  }, [_c('div', {
    staticClass: "element-label"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v("\n        " + _vm._s(_vm.question) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', [(!_vm.question) ? _c('div', {
    staticClass: "element-label"
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "yesno-container",
    class: {
      yes: _vm.value == 'Yes', 'no-value': !_vm.value
    },
    on: {
      "click": _vm.buttonClicked,
      "dblclick": function($event) {
        return _vm.setValue(null)
      }
    }
  }, [_c('div', {
    staticClass: "yesno-slot",
    class: _vm.slotClass
  }), _vm._v(" "), _c('div', {
    staticClass: "yesno-button",
    class: _vm.buttonClass
  }, [(!_vm.value) ? _c('div', {
    staticClass: "display-flex"
  }, [_c('div', {
    staticClass: "hoverable",
    staticStyle: {
      "padding": "9px",
      "text-align": "center",
      "flex-grow": "1",
      "border-right": "solid 1px #ddd",
      "border-top-left-radius": "14px",
      "border-bottom-left-radius": "14px"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setValue('No')
      }
    }
  }, [_vm._v("NO")]), _vm._v(" "), _c('div', {
    staticClass: "hoverable",
    staticStyle: {
      "padding": "9px",
      "text-align": "center",
      "flex-grow": "1",
      "border-top-right-radius": "14px",
      "border-bottom-right-radius": "14px"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setValue('Yes')
      }
    }
  }, [_vm._v("YES")])]) : _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.value) + "\n                ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69fe6579"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/YesNo.vue
// module id = 2589
// module chunks = 1